import React from 'react'
import AddLead from '../addLead/index'

const EditLead=()=> {
  return (
    <AddLead edit={true}/>
  )
}

export default EditLead